import styled from "styled-components";

export const Background = styled.div`

    width: 100vw;
    height: 100vh;

    background-color: var(--color-grey-4);

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;


    span{
        font-size: 100px;
        color: var(--color-grey-0);
    }

    .dot-1{
        animation: dotAnim 1.5s ease infinite;
    }

    .dot-2{
        animation: dotAnim 1.5s ease infinite;
        animation-delay: 200ms;
    }

    .dot-3{
        animation: dotAnim 1.5s ease infinite;
        animation-delay: 400ms;
    }

    @keyframes dotAnim {
        0%{
            opacity: 0.5;
        }50%{
            opacity: 1;

        }
        100%{
            opacity: 0.5;

        }
    }


    h1{
        color: var(--color-grey-0);
    }

    p{
        color: var(--color-grey-1);
    }
`